"use client";

import { useState, useEffect } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
} from "@heroui/react";
import { Menu, X, ChevronDown, ChevronUp } from "lucide-react";
import Link from "next/link";
import Image from "next/image";

export default function NavBarClient({ items }: { items: any[] }) {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<number | null>(null);
  const [openMobileDropdown, setOpenMobileDropdown] = useState<number | null>(null);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 100) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);

      // 👇 NYTT: sätt scrolled när man passerar 50px
      if (window.scrollY > 100) {
        setTimeout(() => {setScrolled(true);}, 500);
        
      } else {
        setTimeout(() => {setScrolled(false);}, 500);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);


  return (
    <>
      <Navbar
        className={`shadow-md text-primary-900 z-20 h-20 transition-all duration-300 ${showNavbar ? "translate-y-0" : "-translate-y-full"
          } ${scrolled ? "bg-white" : "bg-white/20 backdrop-blur-md"}`}
      >
        <NavbarBrand>
          <Link href="/" className="text-xl font-bold">
          
            <Image
              src={"/uploads/logo-nobg-black.png"} // Update with your logo
              alt={"SecretJoy"}
              width={200}
              height={50}
              priority={true}
              className="logo"
            />
          </Link>
        </NavbarBrand>

        {/* Desktop Navigation */}
        <NavbarContent justify="center" className="md:flex hidden gap-6">
          {items.map((item, index) => (
            <div key={index} className="relative group">
              {item.subItems ? (
                <div
                  className="relative"
                  onMouseEnter={() => setOpenDropdown(index)}
                  onMouseLeave={() => setOpenDropdown(null)}
                >
                  <button className={`flex items-center justify-between py-2 text-lg  hover:text-secondary-300 transition-colors text-black`}>
                    <span className="pr-2">{item.title}</span>
                    {openDropdown === index ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </button>
                  {openDropdown === index && (
                    <div className="absolute top-10 left-0 bg-inherit shadow-lg rounded-md min-w-[200px] border border-primary-500">
                      {item.subItems.map((subItem: any) => (
                        <Link
                          key={subItem.key}
                          href={"/category/" + subItem.link}
                          className={`block px-4 py-3  hover:bg-primary-50 transition-colors first:rounded-t-md last:rounded-b-md text-black`}
                        >
                          {subItem.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  href={item.link}
                  className="px-4 py-2 text-lg text-white hover:text-secondary-300 transition-colors"
                >
                  {item.title}
                </Link>
              )}
            </div>
          ))}
        </NavbarContent>

        {/* Mobile Menu Toggle */}
        <NavbarContent className="md:hidden" justify="end">
          <button
            className="p-2 text-white"
            onClick={() => setDrawerOpen(!isDrawerOpen)}
          >
            {isDrawerOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </NavbarContent>
      </Navbar>

      {/* Mobile Drawer */}
      <Drawer isOpen={isDrawerOpen} onOpenChange={setDrawerOpen}>
        <DrawerContent className="bg-primary-800 text-white">
          <DrawerHeader className="flex justify-between items-center border-b border-primary-600">
            <span className="text-xl font-bold">Meny</span>
            <button onClick={() => setDrawerOpen(false)}>
              <X size={24} />
            </button>
          </DrawerHeader>
          <DrawerBody className="px-4">
            {items.map((item, index) => (
              <div key={index} className="border-b border-primary-700 last:border-0">
                {item.subItems ? (
                  <div>
                    <button
                      onClick={() => setOpenMobileDropdown(openMobileDropdown === index ? null : index)}
                      className="w-full flex items-center justify-between py-4 text-lg"
                    >
                      <span>{item.title}</span>
                      {openMobileDropdown === index ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                    </button>
                    {openMobileDropdown === index && (
                      <div className="pb-2">
                        {item.subItems.map((subItem: any) => (
                          <Link
                            key={subItem.key}
                            href={"/category/" + subItem.link}
                            className="block py-3 px-4 text-white hover:bg-primary-700 rounded-md"
                            onClick={() => setDrawerOpen(false)}
                          >
                            {subItem.title}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    href={item.link}
                    className="block py-4 text-lg"
                    onClick={() => setDrawerOpen(false)}
                  >
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
          </DrawerBody>
          <DrawerFooter className="bg-primary-900">
            <div className="text-center text-sm text-primary-300">
              © {new Date().getFullYear()} SecretJoy
            </div>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}